import { render, staticRenderFns } from "./TenantFlowConfigManager.vue?vue&type=template&id=cc8da50e&scoped=true&"
import script from "./TenantFlowConfigManager.vue?vue&type=script&lang=js&"
export * from "./TenantFlowConfigManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8da50e",
  null
  
)

export default component.exports